import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

export enum PaymentMethod {
  CASH = 'cash',
  CREDIT_CARD = 'credit card',
  DEBIT_CARD = 'debit card',
  GCASH = 'g cash',
  QRPH = 'qrph',
}

export const isPaymentMethod = (value: any) => isEnumValue(PaymentMethod, value);

export interface WithPaymentMethod {
  paymentMethod: PaymentMethod;
}
